[
    {
        "Select": {
            "editable": false,
            "pinned": "left",
            "refData": {
                "datatype": "checkbox",
                "selectAll": true,
                "colSize": 50
            },
            "rowGroup": false,
            "hide": false,
            "maxWidth": 50,
            "suppressAutoSize": true
        },
        "Distro Details": {
            "headerName": "Distro Details",
            "marryChildren": true,
            "children": [
                {
                    "Distro Id": {
                        "editable": false,
                        "refData": {
                            "datatype": "string",
                            "showToolTip": false
                        },
                        "rowGroup": false,
                        "hide": false
                    },
                    "Buying Season": {
                        "editable": false,
                        "refData": {
                            "datatype": "string",
                            "showToolTip": false
                        },
                        "rowGroup": false,
                        "hide": false
                    },
                    "STYC ID": {
                        "editable": false,
                        "refData": {
                            "datatype": "string",
                            "showToolTip": false
                        },
                        "rowGroup": false,
                        "hide": false
                    },
                    "STYC Name": {
                        "editable": false,
                        "refData": {
                            "datatype": "string",
                            "showToolTip": false
                        },
                        "rowGroup": false,
                        "hide": false
                    },
                    "Attribute Family": {
                        "editable": false,
                        "refData": {
                            "datatype": "string"
                        },
                        "rowGroup": false,
                        "hide": false,
                        "suppressAutoSize": true
                    },
                    "Attribute Value": {
                        "editable": false,
                        "refData": {
                            "datatype": "string"
                        },
                        "rowGroup": false,
                        "hide": false,
                        "suppressAutoSize": true
                    },
                    "Store ID": {
                        "editable": false,
                        "refData": {
                            "datatype": "string",
                            "showToolTip": false
                        },
                        "rowGroup": false,
                        "hide": false,
                        "sort": "asc"
                    },
                    "Raw Sales": {
                        "editable": false,
                        "refData": {
                            "datatype": "number",
                            "showToolTip": false,
                            "replaceZeros": true,
                            "custom_field": "raw_sales"
                        },
                        "rowGroup": false,
                        "hide": false
                    },
                    "Aug. Sales Units": {
                        "editable": false,
                        "refData": {
                            "datatype": "number",
                            "showToolTip": false,
                            "replaceZeros": true,
                            "custom_field": "aug_sales_units"
                        },
                        "rowGroup": false,
                        "hide": true
                    },
                    "Impact of Lost Sales": {
                        "editable": false,
                        "refData": {
                            "datatype": "number",
                            "showToolTip": false,
                            "replaceZeros": true,
                            "custom_field": "impact_of_lost_sales"
                        },
                        "rowGroup": false,
                        "hide": true
                    },
                    "Distance from (-1)": {
                        "editable": false,
                        "refData": {
                            "datatype": "number",
                            "showToolTip": false,
                            "custom_field": "distance_from_minusone"
                        },
                        "rowGroup": false,
                        "hide": true
                    },
                    "Smoothing Impact": {
                        "editable": false,
                        "refData": {
                            "datatype": "number",
                            "showToolTip": false,
                            "replaceZeros": true,
                            "custom_field": "smoothing_impact"
                        },
                        "rowGroup": false,
                        "hide": true
                    },
                    "Prod. Lvl": {
                        "editable": false,
                        "refData": {
                            "datatype": "string",
                            "showToolTip": false,
                            "custom_field": "optimal_node"
                        },
                        "rowGroup": false,
                        "filter": "agSetColumnFilter",
                        "hide": true
                    },
                    "Source": {
                        "editable": false,
                        "refData": {
                            "datatype": "string",
                            "showToolTip": false
                        },
                        "rowGroup": false,
                        "hide": true
                    },
                    "Status": {
                        "editable": false,
                        "refData": {
                            "datatype": "string",
                            "showToolTip": false,
                            "flexSize": 2
                        },
                        "rowGroup": false,
                        "hide": true
                    },
                    "Edited": {
                        "editable": false,
                        "refData": {
                            "datatype": "boolean",
                            "showToolTip": false
                        },
                        "rowGroup": false,
                        "hide": true
                    },
                    "Last Modified": {
                        "editable": false,
                        "refData": {
                            "datatype": "date",
                            "showToolTip": false
                        },
                        "rowGroup": false,
                        "hide": true
                    },
                    "Last Modified By": {
                        "editable": false,
                        "refData": {
                            "datatype": "string",
                            "showToolTip": false,
                            "flexSize": 2
                        },
                        "rowGroup": false,
                        "hide": true
                    }
                }
            ],
            "refData": {
                "datatype": "string"
            }
        }
    }
]
